@import '@alfalab/core-components-vars/src/index.css';

:root {
    --amount-input-minor-part-and-currency-color: var(--color-light-text-secondary);
    --amount-input-disabled: var(--color-light-text-tertiary);
    --amount-input-input-reject-background-color: var(--color-light-status-muted-negative);
}

.minorPartAndCurrency {
    color: var(--amount-input-minor-part-and-currency-color);

    &.disabled,
    &.readOnly {
        color: var(--amount-input-disabled);
    }
}

/* prettier-ignore */
@each $phase in 0, 1 {
    .inputReject$(phase) {
        animation: reject$(phase) ease 0.3s 1;
    }

    @keyframes reject$(phase) {
        from {
            background-color: var(--amount-input-input-reject-background-color);
        }
    }
}
